import { GridCol, GridContainer } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { mapMarkdownSpot } from '@websrc/DataMappers/mapSpot'
import React from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'
import * as SC from './SpotMarkdown.style'

export interface SpotMarkdownProps {
  spot: ReturnType<typeof mapMarkdownSpot>['markdown']
  LearnMoreButton?: LearnMoreButtonType
}

export const SpotMarkdown = ({ spot, LearnMoreButton }: SpotMarkdownProps) => (
  <GridContainer>
    <GridCol>
      <SC.Wrapper {...spotWrapperProps(spot.caption)}>
        <Markdown center={spot.settings.center_text} markdown={spot.markdown} />
        {LearnMoreButton && (
          <SC.LearnMoreButtonWrapper>
            <LearnMoreButton />
          </SC.LearnMoreButtonWrapper>
        )}
      </SC.Wrapper>
    </GridCol>
  </GridContainer>
)
